export default defineNuxtPlugin((nuxtApp) => {
  let hasChunkError = false

  nuxtApp.hook('app:chunkError', ({ error }) => {
    // Only reload once to avoid infinite loops
    if (!hasChunkError) {
      hasChunkError = true
      console.log('Chunk error detected, reloading page...')
      // Small delay to ensure user sees the page briefly
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  })

  // Also catch Vite-specific errors
  window.addEventListener('vite:preloadError', (event) => {
    if (!hasChunkError) {
      hasChunkError = true
      console.log('Vite preload error, reloading...')
      window.location.reload()
    }
  })
})
